import L from 'leaflet';
import { createControlComponent } from '@react-leaflet/core';
import 'leaflet-routing-machine';

const createRoutineMachineLayer = (props: any) => {
  const instance = (L as any).Routing.control({
    waypoints: [L.latLng(props.from.lat, props.from.lng), L.latLng(props.to.lat, props.to.lng)],
    lineOptions: {
      styles: [{ color: '#6FA1EC', weight: 4 }],
    },
    show: false,
    addWaypoints: false,
    routeWhileDragging: true,
    draggableWaypoints: true,
    fitSelectedRoutes: true,
    showAlternatives: false,
    createMarker: function () {
      return null;
    },
    formatter: new (L as any).Routing.Formatter({
      language: 'en',
    }),
  });

  instance.on('routeselected', function (e: any) {
    const data = { ...e.route, from: props.from, to: props.to };
    sessionStorage.setItem('routeInstrHotels', JSON.stringify(data));
    sessionStorage.setItem('transferDistance', e.route.summary.totalDistance);
  });

  return instance;
};

const RoutingMachine = createControlComponent(createRoutineMachineLayer);

export default RoutingMachine;
